module.exports = require("@walletconnect/utils");